import React from "react";
import Timeline from "./helper-component/Timeline";

const TimeLine = () => {
  return (
    <div className="experience">
      <div className="container">
        <header class="section-header text-center wow zoomIn" data-wow-delay="0.1s">
          <h2>Experience</h2>
        </header>
        <div className="timeline">
          <Timeline
            className="left slideInLeft"
            company="ROOTDEVS."
            company_url="https://rootdevs.com/"
            working_period="Nov 2024 - Present"
            designation="Sr. Software Engineer"
            skills="Nodejs, NextJs, MongoDB, MySQL, Socket.io, Redis, Nginx, AWS EC2, CI/CD, Load Balancer, S3, Cloudfront"
            work_description={[
              "Managed server infrastructure and DevOps, ensuring system reliability, scalability, and security.",
              "Optimized AWS services (EC2, S3, CloudFront) and implemented CI/CD pipelines for seamless deployments.",
              "Supervised multiple projects, ensuring timely delivery and mentoring teammates.",
              "Led R&D for scalable solutions in real-time communication, caching (Redis), and high-concurrency systems.",
              "Enhanced performance monitoring, reducing system latency and improving backend efficiency."
            ]}
          />
          <Timeline
            className="right slideInRight"
            company="ROOTDEVS."
            company_url="https://rootdevs.com/"
            working_period="Feb 2024 - Oct 2024"
            designation="Software Engineer"
            skills="Nodejs, NextJs, MongoDB, MySQL, Socket.io, Redis, Nginx, AWS EC2, S3, Cloudfront"
            work_description={["Developed and maintained backend code for various software applications, ensuring robust and scalable solutions.",
              "Deployed and managed production servers, optimizing performance and ensuring high availability.",
              "Conducted research and development to identify and implement feasible software solutions.",
              "Played a key role in the development of a high performance quiz app, enabling over 10,000 concurrent players to participate and view real time scores."]}
          />
          <Timeline
            className="left slideInLeft"
            company="IOTA INFOTECH LIMITED"
            company_url="https://iotait.tech/"
            working_period="Nov 2022 - Nov 2023"
            designation="Software Engineer"
            skills="PHP, Laravel, MySQL, Nginx, AWS EC2, Cloudfront"
            work_description="As a key contributor to our Human Resources and Management product, I lead the end-to-end process encompassing design, development, and thorough white-box testing. My role ensures the creation of a robust and efficient solution that meets the highest standards of quality and functionality."
          />
          <Timeline
            className="right slideInRight"
            company="IOTA INFOTECH LIMITED"
            company_url="https://iotait.tech/"
            working_period="March 2022 - Oct 2022"
            designation="Associate Software Engineer"
            skills="NodeJS, ExpressJS, ReactJS, Jquery, FCM, MongoDB, MySQL, Sequelize, Nginx, AWS EC2, Bash"
            work_description="I collaborated within cross-functional teams to deliver high-impact projects, including a ride-sharing app and a community app. I played a pivotal role in crafting and optimizing APIs for seamless integration with mobile applications, while also taking charge of designing and developing intuitive web admin panels to effectively manage project operations.  Additionally, I demonstrated proficiency in deploying backend systems to AWS EC2, ensuring optimal performance and scalability."
          />
          <Timeline
            className="left slideInLeft"
            company="IOTA INFOTECH LIMITED"
            company_url="https://iotait.tech/"
            working_period="Sept 2021 - Feb 2022"
            designation="Software Engineer (Trainee)"
            skills="HTML, CSS, Bootstrap, Jquery, PHP, MySQL"
            work_description="I was responsible to design and develop web-based software solutions, collaborating with a team to create a quotation project using HTML, CSS, Bootstrap, jQuery, PHP, and MySQL, contributing to the entire development lifecycle."
          />
        </div>
      </div>
    </div>
  );
};

export default TimeLine;
